<template>
    <div v-if="params.data">
        <span :class="{'line-through text-error': params.data?.deleted}">
            {{ transactionLine.description }}
        </span>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)


const transactionLine = computed(() => {
    return props.params.data
})

</script>

<style scoped>

</style>